<p-toast position="bottom-center"></p-toast>

<div class="card md-form-shell">
  <form
    [formGroup]="subBrandForm"
    novalidate
    autocomplete="off"
    autocorrect="off"
    autocapitalize="off"
    spellcheck="off"
    (ngSubmit)="saveSubBrand()"
  >
    <div class="card-container bg-gray-100 border-round mt-2 p-4">
      <div class="mr-5 flex align-items-center mb-3">
        <i class="pi pi-sitemap mr-2 text-3xl"></i>
        <div class="font-medium text-3xl text-900">{{ pageTitle }}</div>
      </div>

      <div class="grid formgrid p-fluid">
        <div class="field col-12 md:col-6">
          <p-inputgroup>
            <p-inputgroup-addon><i class="pi pi-tag"></i></p-inputgroup-addon>
            <p-iftalabel>
              <input
                pInputText
                type="text"
                formControlName="subBrandName"
                id="subBrandName"
                class="w-full"
                placeholder="Enter sub brand name"
              />
              <label for="subBrandName">Sub Brand Name</label>
            </p-iftalabel>
          </p-inputgroup>
        </div>

        <div class="field col-12 md:col-6">
          <p-inputgroup>
            <p-inputgroup-addon><i class="pi pi-hashtag"></i></p-inputgroup-addon>
            <p-iftalabel>
              <input
                pInputText
                type="text"
                formControlName="subBrandCode"
                id="subBrandCode"
                class="w-full"
                placeholder="Enter sub brand code"
              />
              <label for="subBrandCode">Sub Brand Code</label>
            </p-iftalabel>
          </p-inputgroup>
        </div>

        <app-entity-dropdown-picker
          formControlName="brand"
          [adapter]="brandPickerAdapter"
          inputId="brand"
          label="Brand"
          placeholder="Select a Brand"
          filterPlaceholder="Filter brands"
          columnClass="col-12 md:col-6"
          addonIconClass="pi pi-tags"
        ></app-entity-dropdown-picker>
      </div>
    </div>

    <div class="mt-4 flex justify-content-end gap-2">
      <p-button
        label="Cancel"
        styleClass="p-button-secondary"
        type="button"
        (onClick)="cancel()"
      ></p-button>
      <p-button
        [label]="isEditMode ? 'Update Sub Brand' : 'Save Sub Brand'"
        type="submit"
        [disabled]="subBrandForm.invalid"
      ></p-button>
    </div>
  </form>
</div>
